import { createSlice } from "@reduxjs/toolkit";
import { ReportsV2Type } from "@intelligentlilli/api-layer";

const initialState: ReportsV2Type[] = [];

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setReports(_, action) {
      return action.payload;
    },
  },
});

export const { setReports } = reportsSlice.actions;

export default reportsSlice.reducer;
